// extracted by mini-css-extract-plugin
export default {"title":"Header_title__MvziM","subTitleBlock":"Header_subTitleBlock__hy7t2","subTitle":"Header_subTitle__M0ZsS","images":"Header_images__2s49p"};